import { Box, Typography } from '@mui/material';

import type { PublicSignerSignatureValue } from '../publicSignerTypes';

// Mirror of the validator in publicSignerValidation. Local drafts always
// originate from canvas.toDataURL('image/png'), but a render-site guard
// here defends against any future code path that smuggles a non-data URL
// into a draft and would otherwise leak Referer: /sign/:token.
function isSafeDrawnSignatureUrl(value: string) {
  return value.startsWith('data:image/png;base64,');
}

export function PublicSignerSignaturePreview({
  placeholder,
  value
}: {
  placeholder: string;
  value: PublicSignerSignatureValue | null;
}) {
  if (!value) {
    return (
      <Typography
        noWrap
        sx={{ fontSize: 11, fontWeight: 700, maxWidth: '100%' }}
      >
        {placeholder}
      </Typography>
    );
  }

  if (value.type === 'drawn') {
    if (!isSafeDrawnSignatureUrl(value.drawn_image_data_url)) {
      return null;
    }
    return (
      <Box
        alt="Drawn signature"
        component="img"
        src={value.drawn_image_data_url}
        sx={{
          height: '100%',
          maxWidth: '100%',
          objectFit: 'contain',
          width: '100%'
        }}
      />
    );
  }

  return (
    <Typography
      noWrap
      sx={{
        fontFamily:
          '"Brush Script MT", "Segoe Script", "Snell Roundhand", cursive',
        fontSize: 20,
        lineHeight: 1,
        maxWidth: '100%'
      }}
    >
      {value.typed_name}
    </Typography>
  );
}
